import React, {useEffect, useState} from "react";
import cloneDeep from 'lodash/cloneDeep';
import Select, {SelectMultiple} from "./Select";
import CheckoutModal from '../CheckoutModal';
import AButton from "./AButton";

let tm = {};

function AddPayment(props) {
    let {append} = props;
    let [value, setValue] = useState();

    return <CheckoutModal {...props}>
        <label>Сумма</label>
        <input value={value} onChange={e => setValue(e.target.value)}/>
        <button onClick={event => {
            event.preventDefault();
            append({value: value});
        }}>
            Добавить
        </button>
    </CheckoutModal>
}

function SberIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
        <g fill="none" fillRule="evenodd">
            <circle cx="16" cy="16" r="16" fill="#48B254" fillRule="nonzero"/>
            <path fill="#FFF"
                  d="M22.681 7.368l.945.858-11.932 6.812-5.776-3.325.54-1.073 5.236 2.977 10.987-6.25zM20.279 6l1.268.644-9.853 5.632-4.588-2.602.782-.938 3.806 2.172L20.28 6zm4.184 3.111l.701.939-13.47 7.697-6.505-3.701.297-1.18 6.208 3.54 12.769-7.295zm1.943 3.46c.396 1.109.594 2.27.594 3.486 0 1.216-.198 2.397-.594 3.54l-.27.725a11.142 11.142 0 0 1-2.348 3.486 10.85 10.85 0 0 1-3.51 2.307c-1.385.59-2.815.885-4.291.885-1.494 0-2.925-.295-4.293-.885a11.341 11.341 0 0 1-3.482-2.307 10.568 10.568 0 0 1-2.348-3.486c-.57-1.35-.865-2.8-.864-4.265v-.724l6.694 3.782 14.118-8.046.594 1.502z"/>
        </g>
    </svg>
}

function SberManager(props) {
    let {model, loadOrderData, upField, invoiceStatuses, item} = props;
    let [payEmail, setPayEmail] = useState(model.email);
    let [payPhone, setPayPhone] = useState(model.phone);

    useEffect(() => {
        setPayEmail(model.email);
    }, model ? model.email : '')

    useEffect(() => {
        if(model && model.phone)
            setPayPhone(model.phone);
    }, [model ? model.phone : ''])

    let createSber = (item) => {
        $.get('/order-api/generate-sber', {order_id: model.id, invoice_id: item.id}, () => {
            loadOrderData()
        })
    }

    let sendPayEmail = (item) => {
        $.get('/order-api/send-pay-mail', {
            order_id: model.id,
            email: payEmail,
            invoice_id: item.id
        }, (data) => {
            loadOrderData();
            let str = JSON.stringify(data);
            window.toastr.success(str);
        })
    }

    let sendPayPhone = (item) => {
        $.get('/order-api/send-pay-phone', {
            order_id: model.id,
            phone: payPhone,
            invoice_id: item.id
        }, (data) => {
            loadOrderData();
            let str = JSON.stringify(data);
            window.toastr.success(str);
        })
    }

    if (item.sber) {
        let sberModel = item.sber;

        return <div>
            <SberIcon/>
            <div>
                сумма: {sberModel.sum}
            </div>
            <div>
                sberbank_id: {sberModel.sberbank_id}
            </div>
            <input value={payEmail}
                   onChange={e => setPayEmail(e.target.value)}
                   placeholder="email" type="email"/>

            <AButton onClick={() => sendPayEmail(item)}>Мейл оплаты</AButton>

            <input value={payPhone}
                   onChange={e => setPayPhone(e.target.value)}
                   placeholder="phone" type="text"/>

            <AButton onClick={() => sendPayPhone(item)}>phone оплаты</AButton>
        </div>;
    } else if (item.canCreateSber) {
        return <div>
            <AButton onClick={() => createSber(item)}>Активировать сбербанк</AButton>
        </div>
    }
    return null;
}

export default function InvoicesList(props) {
    let {model, loadOrderData, upField, invoiceStatuses} = props;
    let [showPayModel, setShowPayModel] = useState(false);
    let [currentInvoice, setCurrentInvoice] = useState(null);

    let invoices = model.orderInvoices || [];

    let invoiceChange = (item, field, value) => {
        let index = invoices.indexOf(item);
        let newInvoices = cloneDeep(invoices);
        newInvoices[index][field] = value;
        upField('orderInvoices', newInvoices);

        let k = `${item.id}${field}`;
        clearTimeout(tm[k]);
        tm[k] = setTimeout(() => {
            $.get('/order-api/change-invoice', {invoice_id: item.id, field: field, value: value}, () => {
                window.toastr.success('Сохранено');
                loadOrderData();
            });
        }, 1000);
    };

    let append = (props) => {
        $.post('/order-api/create-payment?invoice_id=' + currentInvoice.id, {sum: props.value}, () => {
            setShowPayModel(false);
            loadOrderData();
        });
    }

    let cif = (invoiceId, field, value) => {
        $.get('/order-api/change-invoice-field?order_id=' + model.id + '&invoice_id=' + invoiceId, {
            field: field,
            value
        }, () => {
            loadOrderData();
        });
    }

    let removePayment = (item) => {
        $.post('/order-api/remove-payment', {order_invoice_item_id: item.id}, () => {
            loadOrderData();
        })
    }

    let allInvoiceSum = invoices.reduce((a, inv) => a + inv.sum, 0);

    let createInvoice = (sum = 0) => {
        $.post('/order-api/add-empty-invoice', {order_id: model.id, sum}, loadOrderData);
    }

    let removeInvoice = (item) => {
        $.post('/order-api/remove-invoice', {id: item.id}, loadOrderData);
    }

    return <div>
        <h2>Оплаты</h2>
        <table className="table table-striped table-condensed table-bordered">
            <thead>
            <tr>
                <th>
                    id
                </th>
                <th>
                    sum
                </th>
                <th>
                    payed
                </th>
                <th>
                    status
                </th>
                <th>
                    shipping
                </th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            {
                invoices.map(item => {
                    let balance = item.sum - item.items.reduce((accumulator, item) => (accumulator) + item.sum, 0);
                    return <tr key={item.id}>
                        <td>
                            #{item.id}
                            <SberManager {...props} item={item}/>
                        </td>
                        <td>
                            <input
                                value={item.sum}
                                onChange={e => invoiceChange(item, 'sum', e.target.value)}
                                disabled={!item.canChange}
                            />
                        </td>
                        <td>
                            {item.payed}

                            {
                                item.items.map(item => {
                                    return <div key={item.id}>
                                        <small style={{fontSize: 9}}>{item.created_at}</small>
                                        &nbsp;
                                        {item.sum} ₽
                                        <a href='#' onClick={event => {
                                            event.preventDefault();
                                            if (confirm('Удалить запись?')) {
                                                removePayment(item);
                                            }
                                        }}>
                                            <span className="glyphicon glyphicon-trash"/>
                                        </a>
                                    </div>
                                })
                            }

                            {item.canPay ? <div>
                                <div>
                                    БАЛАНС: {balance}
                                </div>

                                <AButton
                                    onClick={() => {
                                        setCurrentInvoice(item);
                                        setShowPayModel(true);
                                    }}
                                >
                                    <span className="glyphicon glyphicon-plus-sign"/>
                                </AButton>

                                {balance !== 0 ? <a href='#'
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setCurrentInvoice(item);
                                                        append({value: balance});
                                                    }}
                                                    style={{
                                                        display: "inline-block",
                                                        padding: '4px 8px',
                                                        width: 'auto',
                                                        margin: 3
                                                    }}
                                                    className="btn btn-sm"
                                >
                                    Добавить на сумму
                                </a> : ''}
                            </div> : null}
                        </td>
                        <td>
                            <Select
                                disabled={true}
                                value={item.status}
                                options={invoiceStatuses}
                            />
                        </td>
                        <td>
                            <SelectMultiple
                                value={item.orderInvoiceShippings.map(ois => ois.shipping_id)}
                                onChange={newValues => {
                                    // here must be updated multiple values
                                    // console.log('UPDATE SHIPPINGS', newValues);
                                    cif(item.id, 'orderInvoiceShippings', newValues);
                                }}
                                options={
                                    model.shippings.map(s => ({
                                        id: s.id,
                                        name: s.name
                                    }))
                                }
                            />
                        </td>
                        <td>
                            {
                                item.canDelete ? <a href='#' onClick={event => {
                                    event.preventDefault();
                                    if (confirm('Удалить запрос на оплату?')) {
                                        removeInvoice(item);
                                    }
                                }}>
                                    <span className="glyphicon glyphicon-trash"/>
                                </a> : null
                            }
                        </td>
                    </tr>
                })
            }
            <tr>
                <td>

                </td>
                <td>
                    {allInvoiceSum < model.sum ? <div>
                        Не хватает документов оплаты. Не хватает {model.sum - allInvoiceSum}
                        <a href='#' onClick={e => {
                            e.preventDefault();
                            createInvoice(model.sum - allInvoiceSum);
                        }}>Создать</a>
                    </div> : ''}

                    Полная сумма заказа: {model.sum} (платежей на {allInvoiceSum})

                </td>
                <td></td>
                <td></td>
                <td></td>


            </tr>
            </tbody>
        </table>

        <button onClick={e => {
            e.preventDefault();
            createInvoice();
        }}>
            Добавить
        </button>

        <AddPayment
            isOpen={showPayModel}
            onRequestClose={() => setShowPayModel(false)}
            append={append}
        />
    </div>
}